import { getChannelStatus, getUserRole } from '../../slice';
import { Store } from '../../store';

export const dataURLtoFile = (dataurl, filename) => {
    let dataarr = dataurl.split(','),
        mime = dataarr[0].match(/^data:(.*?);/),
        bstr = atob(dataarr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    //NOSONAR
    while (n--) {
        const charbuffer = bstr.charCodeAt(n);
        u8arr[n] = charbuffer;
    }
    let blob = new Blob([u8arr], { type: mime[1] });
    blob['lastModifiedDate'] = new Date();
    blob['name'] = filename;
    return blob;
};

export const getLocalUserDetails = () => {
    const vCardData = Store.getState().vCardData;
    return vCardData?.data;
};

export const getActionsEnabled = channelId => {
    const userRole = getUserRole(channelId);
    const status = getChannelStatus(channelId);
    const channelRestricted = status === 'DELETED' || status === 'INACTIVE' || userRole === 0;
    return channelRestricted;
};
